import React, { useEffect, useRef, useState } from "react";
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from "../../services/sessionStorageServices"; // Adjust the path as necessary

import "./AddToCart.css";
import Header from "../Header";

import { Button, message, Steps, Modal, Input, Divider, Spin } from "antd";
import CartSummary from "./CartSummary";
import ShippingAddress from "./ShippingAddress";
import PaymentMethod from "./PaymentMethod";
import { FaShoppingCart } from "react-icons/fa";
import { getProfile } from "../../services/localStorageServices";
import { NavLink, useNavigate } from "react-router-dom";
import { useCartContext } from "../../context/addToCart";
import { post } from "../../apiService";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { MdNavigateNext } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import { IoMail } from "react-icons/io5";
import { FaCheckCircle } from "react-icons/fa";
import BannerComp from "../BannerComp";

const { TextArea } = Input;

export const AddToCart = () => {
  const navigate = useNavigate();
  const { profile } = getProfile();
  const { cartValue, setCartValue } = useCartContext();
  // const { addToCart } = getAddToCart();
  const [current, setCurrent] = useState(0);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [messageInput, setMessageInput] = useState("");
  const [orderSubTotal, setOrderSubTotal] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [shippingCharges, setShippingCharges] = useState(0); // Example shipping charges
  const [bookingBy, setBookingBy] = useState();
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");

  const showModal = () => {
    setOpen(true);
  };

  const steps = [
    {
      title: "Cart Summary",
      content: <CartSummary />,
    },
    {
      title: "Shipping Address",
      content: <ShippingAddress profile={profile} />,
    },
    {
      title: "Payment Method",
      content: (
        <PaymentMethod
          comment={comment}
          setComment={setComment}
          bookingBy={bookingBy}
          setBookingBy={setBookingBy}
        />
      ),
    },
  ];

  useEffect(() => {
    if (!profile || profile.verify == "0") {
      navigate("/");
    }
    // eslint-disable-next-line
  }, []);

  function calculateShippingCost(totalAmount) {
    let shippingCost;

    switch (true) {
      case totalAmount < 6000:
        shippingCost = 150;
        break;
      case totalAmount >= 6000 && totalAmount <= 15000:
        shippingCost = 80;
        break;
      case totalAmount > 15000:
        shippingCost = 0; // Free shipping
        break;
      default:
        shippingCost = 0; // Fallback case
        break;
    }

    return shippingCost;
  }

  useEffect(() => {
    // Calculate order subtotal
    let subtotal = 0;
    let delivery = 0;
    let total = 0;
    let total_weight = 0;

    cartValue.forEach((element) => {
      subtotal += parseFloat(
        element.subtotal ? element.subtotal : element.updatedPrice
      ); // Accumulate subtotal as a number
    });

    cartValue.forEach((element) => {
      total_weight += parseFloat(element.total_weight); // Accumulate subtotal as a number
    });

    total_weight = parseFloat(total_weight).toFixed(2);
    subtotal = parseFloat(subtotal.toFixed(2));
    delivery = parseFloat(calculateShippingCost(subtotal).toFixed(2));
    total = parseFloat((subtotal + delivery).toFixed(2));

    // Update state
    setTotalWeight(total_weight);
    setOrderSubTotal(subtotal);
    setShippingCharges(delivery);
    setFinalAmount(total);
  }, [cartValue]);
  const paypalOptions = {
    "client-id":
      "AUYknAU0C1S4mkEyL8H1g1hpq27yuIOvmIPBU_pPPPjGbsmQh2ussCLBXh7YnHAnkmcs5iq7rYMNZbzT",
  };

  // console.log(addToCart)
  const handleCancel = () => {
    setOpen(false);
  };
  const next = () => {
    if (current === steps.length - 2) {
      // Update the finalAmount
      const updatedAmount = finalAmount; // Update this as needed
      setFinalAmount(updatedAmount);

      // Store the updated amount in sessionStorage
      storeAmountInSessionStorage(updatedAmount);
    }
    setCurrent(current + 1);
    handleActive();
  };

  const sectionRef = useRef(null);

  const handleActive = () => {
    const offset = 280;
    const sectionTop = sectionRef.current?.getBoundingClientRect().top;
    window.scrollTo({
      top: sectionTop,
      behavior: "smooth",
    });
  };

  const prev = () => {
    setCurrent(current - 1);
    handleActive();
  };
  const items = steps?.map((item) => ({
    key: item.title,
    title: item.title,
  }));
  // Function to store the amount in sessionStorage with Base64 encryption
  const storeAmountInSessionStorage = (amount) => {
    const amountString = amount.toString(); // Convert amount to string
    const encryptedAmount = btoa(amountString); // Encrypt the string using Base64
    sessionStorage.setItem("toatlAmount", encryptedAmount); // Store in sessionStorage
    console.log("Amount stored in sessionStorage:", encryptedAmount);
  };

  const handleCreateOrder = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("total", finalAmount);
    formData.append("currency", "US");
    formData.append("shipping_charges", shippingCharges);
    formData.append("user_id", profile.user_id);
    formData.append("sub_total", orderSubTotal);
    formData.append("total_weight", totalWeight);
    formData.append("staff_id", profile.refer_by);
    formData.append("comment", comment);
    formData.append("payment_type", "online");
    cartValue.forEach((product) => {
      formData.append("product_list[]", product.cart_id);
    });
    formData.append("action", "add");

    try {
      const response = await post("/orders.php", formData); // Adjust API endpoint
      if (response) {
        setLoading(false);
        message.success("order generated.");
        setSessionStorageItem("order_id", response.message.id);
        //  setOrderId(response.message.id); // Store order ID
        return true;
      }
    } catch (error) {
      setLoading(false);
      console.error("Error creating order:", error);
      message.error("An error occurred while creating the order.");
      return false;
    }
  };
  const getTotalPrice = () => {
    let paymentDetails = null;
    const encodedString = sessionStorage.getItem("toatlAmount");

    if (encodedString) {
      // Decode the string and parse it as JSON
      const jsonString = atob(encodedString);
      paymentDetails = JSON.parse(jsonString);
      console.log(paymentDetails);
    }
    return 3;
  };

  const handleUpdateOrder = async (responseId) => {
    const orderId = getSessionStorageItem("order_id");
    const formData = new FormData();
    formData.append("order_id", orderId);
    formData.append("response_id", responseId);
    formData.append("action", "update");
    formData.append("order_status", "success");

    try {
      const response = await post("/orders.php", formData);
      if (response) {
        setLoading(false);
        message.success("Order successfully!");
        navigate(`/payment-sucess/${orderId}`);
        sessionStorage.removeItem("cart");
        setCartValue([]);
      }
    } catch (error) {
      setLoading(false);
      navigate(`/payment-failed/${orderId}`);
      console.error("Error updating order:", error);
      message.error("An error occurred while updating the order.");
    }
  };

  const payOnOrder = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("total", finalAmount);
      formData.append("currency", "US");
      formData.append("shipping_charges", shippingCharges);
      formData.append("user_id", profile.user_id);
      formData.append("sub_total", orderSubTotal);
      formData.append("total_weight", totalWeight);
      formData.append("staff_id", profile.refer_by);
      formData.append("comment", comment);
      formData.append("payment_type", "offline");
      cartValue.forEach((product) => {
        formData.append("product_list[]", product.cart_id);
      });
      formData.append("action", "add");

      const response = await post("/orders.php", formData);

      if (response) {
        const formData = new FormData();
        formData.append("order_id", response.message.id);
        formData.append("response_id", "");
        formData.append("action", "update");
        formData.append("order_status", "success");

        const resp = await post("/orders.php", formData);

        if (resp) {
          setLoading(false);
          message.success("Order successfully!");
          navigate(`/payment-sucess/${response.message.id}`);
          setCartValue([]);
          sessionStorage.removeItem("cart");
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error creating order:", error);
      message.error("An error occurred while creating the order.");
    }
  };

  const orderEnquiry = async () => {
    try {
      setConfirmLoading(true);
      const formData = new FormData();
      formData.append("name", profile.name);
      formData.append("number", profile.number);
      formData.append("email", profile.user_email);
      formData.append("message", messageInput);
      formData.append("sub_total", orderSubTotal);
      formData.append("total_weight", totalWeight);
      formData.append("title", "Cart Product Enquiry");
      formData.append("shipping_charges", shippingCharges);
      formData.append("total", finalAmount);
      formData.append("dataProduct", JSON.stringify(cartValue));
      formData.append("action", "add");

      const resp = await post("/enquiry.php", formData);

      if (resp) {
        setConfirmLoading(false);
        setMessageInput("");
        setOpen(false);
        message.success(
          "Thank you for your inquiry. Our team will connect with you shortly."
        );
      }
    } catch (error) {
      setConfirmLoading(false);
      message.error("Unable to submit enquiry please try again !");
      console.error(error);
    }
  };

  console.log(cartValue);

  return (
    <Spin spinning={loading}>
      <Header />
      <BannerComp
        title="Cart"
        breadcrumb={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "Cart",
          },
        ]}
        image="https://cdn.shopify.com/s/files/1/1115/6326/files/B1004_Diamonds_banner_2_thumb_61466c50-3bfb-4d54-a2b3-205219e956f5.jpg?v=1511876014"
      />
      <section className="addToCart-sec-steps" ref={sectionRef}>
        <div className="container">
          <div className="addToCart-checkout-main-div-start">
            <Steps direction="horizontal" current={current} items={items} />
            <div className="row mt-5">
              <div
                className={
                  cartValue.length > 0
                    ? `col-xl-9 col-lg-12 mb-xl-5`
                    : `col-12 mb-xl-5`
                }
              >
                <div style={{ minHeight: "210px" }}>
                  {steps[current].content}
                </div>
                {cartValue.length > 0 ? (
                  <div className="d-xl-flex d-none justify-content-end align-items-center mt-3">
                    <Button
                      className="addToCart-next-done-btn"
                      style={{
                        margin: "0 8px",
                        height: "40px",
                      }}
                      onClick={() => (current > 0 ? prev() : navigate(-1))}
                    >
                      <GrFormPrevious />
                      &nbsp;{current > 0 ? "Previous" : "Go Back"}
                    </Button>

                    {current === steps.length - 1 &&
                      (bookingBy === "payNow" ? (
                        <PayPalScriptProvider options={paypalOptions}>
                          <PayPalButtons
                            fundingSource="paypal"
                            style={{
                              layout: "vertical", // Options: 'vertical', 'horizontal'
                              color: "blue", // Options: 'blue', 'silver', 'white', 'black'
                              shape: "rect", // Options: 'rect', 'pill'
                              label: "paypal", // Options: 'paypal', 'checkout', 'buynow', 'pay'
                              height: 40, // Adjust the height of the button
                            }}
                            createOrder={async (data, actions) => {
                              // Create the order in your backend first
                              const orderCreated = await handleCreateOrder();
                              if (orderCreated) {
                                // Proceed with PayPal order creation if backend order creation is successful
                                return actions.order.create({
                                  purchase_units: [
                                    {
                                      amount: {
                                        currency_code: "USD",
                                        value: getTotalPrice(),
                                      },
                                    },
                                  ],
                                });
                              } else {
                                // Prevent PayPal order creation by returning undefined (do not call actions.order.create)
                                return;
                              }
                            }}
                            onApprove={async (data, actions) => {
                              try {
                                const order = await actions.order.capture();
                                const responseId = order.id; // PayPal order ID
                                await handleUpdateOrder(responseId); // Update order with payment details
                              } catch (error) {
                                console.error("Error capturing order:", error);
                                message.error(
                                  "Payment failedssss. Please try again."
                                );
                              }
                            }}
                            onError={(err) => {
                              console.error("PayPal error:", err);
                              message.error(
                                "Payment failed. Please try again."
                              );
                            }}
                          />
                        </PayPalScriptProvider>
                      ) : bookingBy === "payOnOrder" ? (
                        <Button
                          className="checkPlace"
                          style={{ height: "40px" }}
                          onClick={payOnOrder}
                        >
                          Place Order
                          <FaCheckCircle />
                        </Button>
                      ) : (
                        ""
                      ))}

                    {profile.type === "user"
                      ? current < steps.length - 1 && (
                          <Button
                            className="addToCart-next-done-btn"
                            style={{ height: "40px" }}
                            onClick={() => next()}
                          >
                            Next&nbsp;
                            <MdNavigateNext />
                          </Button>
                        )
                      : null}
                  </div>
                ) : (
                  ""
                )}
              </div>
              {cartValue.length > 0 && (
                <div className="col-xl-3 col-lg-12">
                  <div className="">
                    <div className="orderDetail mt-4">
                      <h4>Order summary</h4>
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="d-block">Subtotal </label>
                        <label className="d-block">$ {orderSubTotal} </label>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="d-block">Shipping </label>
                        <label className="d-block">$ {shippingCharges} </label>
                      </div>
                      <Divider />
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="d-block">
                          <strong>Total</strong>{" "}
                        </label>
                        <label className="d-block">$ {finalAmount} </label>
                      </div>
                    </div>
                    {cartValue.length > 0 ? (
                      <div className="d-flex d-xl-none justify-content-end align-items-center mt-4">
                        <div className="w-100 d-flex justify-content-between">
                          <Button
                            className="addToCart-next-done-btn"
                            style={{
                              margin: "0 8px",
                              height: "40px",
                            }}
                            onClick={() =>
                              current > 0 ? prev() : navigate(-1)
                            }
                          >
                            <GrFormPrevious />
                            &nbsp;{current > 0 ? "Previous" : "Go Back"}
                          </Button>

                          {current === steps.length - 1 &&
                            (bookingBy === "payNow" ? (
                              <PayPalScriptProvider options={paypalOptions}>
                                <PayPalButtons
                                  fundingSource="paypal"
                                  style={{
                                    layout: "vertical", // Options: 'vertical', 'horizontal'
                                    color: "blue", // Options: 'blue', 'silver', 'white', 'black'
                                    shape: "rect", // Options: 'rect', 'pill'
                                    label: "paypal", // Options: 'paypal', 'checkout', 'buynow', 'pay'
                                    height: 40, // Adjust the height of the button
                                  }}
                                  createOrder={async (data, actions) => {
                                    // Create the order in your backend first
                                    const orderCreated =
                                      await handleCreateOrder();
                                    if (orderCreated) {
                                      // Proceed with PayPal order creation if backend order creation is successful
                                      return actions.order.create({
                                        purchase_units: [
                                          {
                                            amount: {
                                              currency_code: "USD",
                                              value: getTotalPrice(),
                                            },
                                          },
                                        ],
                                      });
                                    } else {
                                      // Prevent PayPal order creation by returning undefined (do not call actions.order.create)
                                      return;
                                    }
                                  }}
                                  onApprove={async (data, actions) => {
                                    try {
                                      const order =
                                        await actions.order.capture();
                                      const responseId = order.id; // PayPal order ID
                                      await handleUpdateOrder(responseId); // Update order with payment details
                                    } catch (error) {
                                      console.error(
                                        "Error capturing order:",
                                        error
                                      );
                                      message.error(
                                        "Payment failedssss. Please try again."
                                      );
                                    }
                                  }}
                                  onError={(err) => {
                                    console.error("PayPal error:", err);
                                    message.error(
                                      "Payment failed. Please try again."
                                    );
                                  }}
                                />
                              </PayPalScriptProvider>
                            ) : bookingBy === "payOnOrder" ? (
                              <Button
                                className="checkPlace"
                                style={{ height: "40px" }}
                                onClick={payOnOrder}
                              >
                                Place Order
                                <FaCheckCircle />
                              </Button>
                            ) : (
                              ""
                            ))}

                          {profile.type === "user"
                            ? current < steps.length - 1 && (
                                <Button
                                  className="addToCart-next-done-btn"
                                  style={{ height: "40px" }}
                                  onClick={() => next()}
                                >
                                  Next&nbsp;
                                  <MdNavigateNext />
                                </Button>
                              )
                            : null}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {profile.type === "user" && cartValue.length > 0 && (
                      <Button
                        className="mt-3 w-100"
                        onClick={showModal}
                        icon={<IoMail />}
                        style={{
                          height: "40px",
                          background: "#000",
                          color: "#fff",
                        }}
                      >
                        Make an Enquiry
                      </Button>
                    )}
                  </div>
                </div>
              )}
            </div>
            <Divider orientation="center">Notice</Divider>
            <div className="row my-5">
              <div className="col-md-4 mb-3">
                <div className="noticeCards">
                  <h4> Terms and Condition</h4>
                  <ul>
                    <li>All Price listed are in US Dollars.</li>
                    <li>Price DO NOT include taxes and shipping.</li>
                    <li>
                      Please call or email with any inquiries for available
                      stock
                    </li>
                    <li>
                      Contact for LB /LC /NATTS and Single Cuts and for big
                      quantities
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="noticeCards">
                  <h4> Handling Time / Shipping Time</h4>
                  <ul>
                    <li>
                      Mostly will in ship 1-2 Business Days of receiving
                      payment.
                    </li>
                    <li>
                      Shipping Charges: $150 through Fedex for Invoice value
                      below $5000 USD.
                    </li>
                    <li>
                      $80 for through Fedex for Invoice value between
                      $5000-15000.
                    </li>
                    <li>
                      Free Shipping through Fedex for Shipment above $15000 USD
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="noticeCards">
                  <h4> Support</h4>
                  <ul>
                    <li>
                      <NavLink to="tel:+91 9326713857">+91 9326713857</NavLink>
                    </li>
                    <li>
                      <NavLink to="mailto:websales@sejalgems.in">
                        websales@sejalgems.in
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        title="Product Form Enquiry"
        open={open}
        onCancel={handleCancel}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
            className="addToCart-next-done-btn-primary-unset-btn"
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            className="addToCart-next-done-btn"
            loading={confirmLoading}
            onClick={orderEnquiry}
          >
            Submit
          </Button>,
        ]}
      >
        <div className="d-flex gap-3 align-items-center mb-3">
          <label className="d-block">
            <FaShoppingCart
              style={{ color: "rgb(196,94,155)", fontSize: "20px" }}
            />
          </label>
          <label className="d-block">
            All the product in cart will send for enquiry
          </label>
        </div>
        <TextArea
          value={messageInput}
          onChange={(e) => setMessageInput(e.target.value)}
          rows={4}
          placeholder="Message"
        />
      </Modal>
    </Spin>
  );
};
